export default "__VITE_ASSET__223820e4__"